import { useEffect, useRef, useState } from "react";
import SelectErp from "../basics/SelectErp";

let typingTimer = null;

// Componente select de pesquisa para api v3
// To Do:  não finalizado, realizar testes

const SearchSelectGFApi = ({
  label = "",
  value,
  variant = "standard",
  setValue,
  error,
  helperText,
  queryFn = async () => {},
  descriptionField = "description",
  disabled = false,
  onChange = (e) => {
    setValue(e);
  },
  getOptionLabel,
  customChange = false,
  disabledTextSearch = true,
  handleRequestArray = null,
  handleRequestFilters = (text = "") => {},
  ...props
}) => {
  const [text, setText] = useState("");
  const [optionsList, setOptionsList] = useState([]);
  const inputRef = useRef();
  const [loading, setLoading] = useState(false);
  const handleSearchText = (e) => {
    setText(e.target.value);
  };

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      try {
        setLoading(true);

        const requestFilter = handleRequestFilters(text);

        const callback = await queryFn({
          ...requestFilter,
        });

        if (callback && callback.success) {
          const resultRequest = handleRequestArray
            ? handleRequestArray(callback.data)
            : callback.data;
          setOptionsList(resultRequest);
          if (resultRequest.length === 1 && !customChange) {
            setValue(resultRequest[0]);
            inputRef.current.blur();
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }, 1200);
  }, [text, customChange, queryFn, setValue]); // eslint-disable-line

  return (
    <SelectErp
      disabledSearchByText={disabledTextSearch}
      inputRef={inputRef}
      variant={variant}
      label={label}
      value={value}
      setValue={setValue}
      disabled={disabled}
      optionsList={optionsList}
      getOptionLabel={getOptionLabel}
      error={error}
      onChangeText={handleSearchText}
      onChange={(e) => {
        onChange(e);
      }}
      loading={loading}
      helperText={helperText}
      descriptionField={descriptionField}
      {...props}
    />
  );
};

export default SearchSelectGFApi;
